import { render, staticRenderFns } from "./chome.vue?vue&type=template&id=56672869&scoped=true&"
import script from "./chome.vue?vue&type=script&lang=js&"
export * from "./chome.vue?vue&type=script&lang=js&"
import style0 from "./chome.vue?vue&type=style&index=0&id=56672869&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56672869",
  null
  
)

export default component.exports